// Reads the GA4 client_id and session_id from the first-party GA cookies so they
// can be stamped onto the cart line at add-to-cart. Only values written to the
// order survive the Shopify checkout/thank-you sandbox — so the server-side order
// webhook re-sends them with a GA4 Measurement Protocol event, which lets GA4
// join the purchase to the same user + session as the buy-box clicks.

// EU web-stream measurement id. The GA4 session cookie is _ga_<id without the G- prefix>.
const GA_SESSION_COOKIE = "_ga_T88B5TR90J";

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const match = document.cookie.match("(?:^|; )" + escaped + "=([^;]*)");
  return match ? decodeURIComponent(match[1]) : null;
}

// _ga = "GA1.1.<a>.<b>" -> client_id = "<a>.<b>" (last two segments)
// _ga_<id> session cookie holds the session_id in its 3rd dot-segment, in one of
// two formats: older GS1 ("GS1.1.<sid>.<n>...") where it's plain digits, or newer
// GS2 ("GS2.1.s<sid>$o..$g..$t..") where it's the digits after a leading "s".
export function getGaIds() {
  // Never let cookie reading/parsing throw — this runs while building the
  // add-to-cart payload (incl. the sticky bar, which has no try/catch), so any
  // failure must degrade to empty ids, never break add-to-cart.
  try {
    const ga = readCookie("_ga");
    const clientId = ga ? ga.split(".").slice(-2).join(".") : "";

    const gaSession = readCookie(GA_SESSION_COOKIE);
    const seg = gaSession ? gaSession.split(".")[2] || "" : "";
    const sidMatch = seg.match(/^s?(\d+)/); // GS2 "s<sid>$..." or GS1 "<sid>"
    const sessionId = sidMatch ? sidMatch[1] : "";

    return {clientId, sessionId};
  } catch (e) {
    return {clientId: "", sessionId: ""};
  }
}

// The clicks/views tag content_id as GTM's "Page URL without parameters"
// (protocol + host + path). Match it so buybox_purchase reuses the same Content ID.
function pageUrlNoParams() {
  if (typeof location === "undefined") return "";
  return location.origin + location.pathname;
}

// Line-item properties that carry the GA identity onto the order. Underscore-
// prefixed so they stay hidden from the customer but persist to the order/webhook.
export function buyboxGaProps() {
  const {clientId, sessionId} = getGaIds();
  return {
    _buybox_client_id: clientId,
    _buybox_session_id: sessionId,
    _buybox_content_id: pageUrlNoParams(),
  };
}
